import React, { Fragment } from 'react'
import { Record } from 'immutable'

import { Icon } from '@zambezi/sdk/icons'
import { IsViewport } from '@zambezi/layout-grid'

import { StoreLink } from '../navigation'
import style from './NavBar.module.css'

export const NavItem = Record({
  label: 'LABEL NOT SPECIFIED',
  link: '/',
})

export default function NavBar(props) {
  return (
    <Fragment>
      <IsViewport isTablet isDesktop isWidescreen>
        <NavBarTabletOrDesktop {...props} />
      </IsViewport>
      <IsViewport isMobile>
        <NavBarMobile {...props} />
      </IsViewport>
    </Fragment>
  )
}

function NavBarTabletOrDesktop({ items = [], padded }) {
  return (
    <div
      className={`${
        padded ? style.paddedContainer : style.container
      } js-navbar`}
    >
      <StoreLink
        className={`${style.home} js-home-icon`}
        to="/"
        aria-label="home"
      >
        <svg className="zb-icon zb-icon-xsmall">
          <use xlinkHref="#ob-home-icon" />
        </svg>
      </StoreLink>
      {items.map(({ label, link }, index) => (
        <Fragment key={label}>
          <Icon name="chev-right-xsmall" aria-hidden="true" />
          <StoreLink
            index={index}
            to={link}
            className={`${style.item} js-nav-link-${index}`}
          >
            {label}
          </StoreLink>
        </Fragment>
      ))}
    </div>
  )
}

function NavBarMobile({ items = [], padded }) {
  return (
    <div
      className={`${
        padded ? style.paddedContainer : style.container
      } js-navbar`}
    >
      <StoreLink className={`${style.home} js-home-icon`} to="/">
        <svg className="zb-icon zb-icon-small">
          <use xlinkHref="#ob-home-icon" />
        </svg>
      </StoreLink>
      {items.length > 0 && (
        <StoreLink
          to={items[items.length - 1].link}
          className={`${style.item} js-nav-link-back`}
        >
          Back
        </StoreLink>
      )}
    </div>
  )
}
